module.exports = __webpack_public_path__ + "static/media/US.19640705.svg";